import { render, staticRenderFns } from "./UserOrders.vue?vue&type=template&id=6c7e263c&scoped=true"
import script from "./UserOrders.vue?vue&type=script&lang=js"
export * from "./UserOrders.vue?vue&type=script&lang=js"
import style0 from "./UserOrders.vue?vue&type=style&index=0&id=6c7e263c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e263c",
  null
  
)

export default component.exports